module.exports = __webpack_public_path__ + "img/组6024.dbdf0981.svg";